<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0">
                <span class="text-before-button">{{ unitOfMeasure.name }}</span>
                <base-button
                  v-if="$currentUserCan($permissions.PERM_EDIT_PRODUCTS)"
                  type="primary"
                  icon
                  size="sm"
                  @click="editUnitOfMeasure()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="$currentUserCan($permissions.PERM_DELETE_PRODUCTS)"
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteUnitOfMeasure()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'unit-of-measures'"
                :objectId="unitOfMeasure.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
              :key="renderKey"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <unit-of-measure-view-global :unitOfMeasure="unitOfMeasure" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <unit-of-measure-view-logs :unitOfMeasure="unitOfMeasure" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import defaultUnitOfMeasure from "./defaultUnitOfMeasure";
import UnitOfMeasureViewGlobal from "./partials/UnitOfMeasureViewGlobal.vue";
import UnitOfMeasureViewLogs from "./partials/UnitOfMeasureViewLogs.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    NotificationSubscription,
    UnitOfMeasureViewGlobal,
    UnitOfMeasureViewLogs,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      renderKey: 0,
      unitOfMeasure: cloneDeep(defaultUnitOfMeasure),
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("unitOfMeasures/get", id);
        this.unitOfMeasure =
          this.$store.getters["unitOfMeasures/unitOfMeasure"];
        this.renderKey++;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editUnitOfMeasure() {
      this.$router.push({
        name: "Edit UnitOfMeasure",
        params: { id: this.unitOfMeasure.id },
      });
    },

    async deleteUnitOfMeasure() {
      const confirmation = await swal.fire({
        title: this.$t("PRODUCTS.DELETE_THIS_UNIT_OF_MEASURE"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch(
            "unitOfMeasures/destroy",
            this.unitOfMeasure.id
          );
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("PRODUCTS.UNIT_OF_MEASURE_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List UnitOfMeasures" });
    },
  },
};
</script>
